<template>
  <div>
    <b-modal
      ref="modal"
      class="modal-info"
      content-class="rounded-10 position-relative"
      hide-footer
      hide-header
      :title="title"
      :visible="value"
      centered
      :dialog-class="`${size}-modal`"
      @hide="close"
      @close="close"
    >
      <div class="header text-18 font-weight-bold">
        {{ title }}
        <span
          class="btn-close text-primary cursor-pointer position-absolute text-32 icon-X"
          @click="close"
        >
        </span>
      </div>
      <div class="main" :class="{'no-content-gap': noContentGap}">
        <div style="max-height: 353px; overflow-y: auto" class="scroll-bar">
          <slot></slot>
        </div>
      </div>
      <div v-if="!hideFooter" class="footer">
        <b-button
          v-if="!hideCancel"
          variant="secondary"
          class="d-block mx-auto text-14"
          size="lg"
          @click="cancel"
        >
          {{ $t(cancelText) }}
        </b-button>
        <b-button
          v-if="!hideConfirm"
          variant="primary"
          class="d-block mx-auto text-14"
          size="lg"
          @click="confirm"
        >
          {{ $t(confirmText) }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    hideConfirm: {
      type: Boolean,
      default: false,
    },
    noContentGap: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: '確定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    title: {
      type: String,
      default: '標題',
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    cancel() {
      this.$emit('cancel');
      this.close();
    },
    confirm() {
      this.$emit('confirm');
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .modal-dialog {
  margin: 0.5rem auto;
  &.sm-modal {
    width: 337px;
    min-width: 337px;
    max-width: 100%;
  }
  &.md-modal {
    width: 600px;
    min-width: 600px;
  }
  .modal-body {
    padding: 0;
  }
  .btn-close {
    top: 14px;
    right: 6px;
  }
  .header {
    padding: 15px 16px;
    border-bottom: 1px solid $line-1;
    color: $font-grayscale-1;
  }
  .footer {
    padding: 8px 16px;
    border-top: 1px solid $line-1;
  }
  .main {
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    padding: 16px;
    line-height: 28px;
    & > div {
      border: 1px solid $line-1;
      padding: 16px;
      border-radius: var(--Radius-radius-s, 6px);
      border: 1px solid $line-1;
      background: var(--Background-style-2, #f8f9fb);
    }
    &.no-content-gap {
      padding: 32px;
      & > div {
        border: 0;
        padding: 0;
        border-radius: 0;
        background: rgba(0, 0, 0, 0);
      }
    }
  }
}
</style>
